import React from 'react';
import moment from 'moment';
import { useField } from 'formik';
import DatePicker from 'components/new-ui/base/date-picker/DatePicker';
import { ErrorDiv } from '../../styles';
import { ETA_FORMAT } from '../../utils';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

type Props = {};
const EtaDatePicker: React.FC<Props> = () => {
    const [field, meta, helpers] = useField('shipmentDetails.eta');

    const label = 'ETA:';
    const required = true;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <span>
                {required && <LabelRequiredSymbol style={{ marginRight: 8 }} />}
                {label}
            </span>
            <div
                style={{
                    maxWidth: 489,
                    flexGrow: 1,
                }}
            >
                <DatePicker
                    id={field.name}
                    style={{
                        width: '100%',
                    }}
                    aria-required
                    showTime
                    showNow={false}
                    placeholder="Select estimated time of arrival"
                    format={ETA_FORMAT}
                    value={field.value ? moment(field.value) : null}
                    onChange={(date) => {
                        const isoString = date ? date.toISOString() : null;
                        helpers.setValue(isoString);
                    }}
                    onBlur={() => {
                        helpers.setTouched(true);
                    }}
                    status={meta.touched && meta.error ? 'error' : undefined}
                />
                {meta.touched && meta.error && <ErrorDiv>{meta.error}</ErrorDiv>}
            </div>
        </div>
    );
};

export default EtaDatePicker;
